import { useQuery } from '@tanstack/react-query';
import { productsService } from '../services/products.service';

export interface AccessibleProduct {
  id: number;
  name: string;
  slug: string;
  active?: boolean;
}

export function useAccessibleProducts() {
  return useQuery<{ data: AccessibleProduct[] } | AccessibleProduct[], Error, AccessibleProduct[]>({
    queryKey: ['accessible-products'],
    queryFn: () => productsService.list(),
    select: (resp) => {
      const list = (Array.isArray(resp) ? resp : resp.data) as AccessibleProduct[];
      return list.filter((p) => p.active !== false);
    },
  });
}
